/* tslint:disable */
/* eslint-disable */
/* @relayHash ca48fa3fd7649fc0c004855a968cd08a */

import { ConcreteRequest } from "relay-runtime";
export type DeleteMembershipInput = {
    id: string;
    clientMutationId?: string | null;
};
export type DeleteMembershipMutationVariables = {
    input: DeleteMembershipInput;
};
export type DeleteMembershipMutationResponse = {
    readonly deleteMembership: {
        readonly deletedMembershipId: string;
    } | null;
};
export type DeleteMembershipMutation = {
    readonly response: DeleteMembershipMutationResponse;
    readonly variables: DeleteMembershipMutationVariables;
};



/*
mutation DeleteMembershipMutation(
  $input: DeleteMembershipInput!
) {
  deleteMembership(input: $input) {
    deletedMembershipId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMembershipInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMembership",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMembershipPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedMembershipId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteMembershipMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteMembershipMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteMembershipMutation",
    "id": null,
    "text": "mutation DeleteMembershipMutation(\n  $input: DeleteMembershipInput!\n) {\n  deleteMembership(input: $input) {\n    deletedMembershipId\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '6ad67634c99b107d45ac42569ea68055';
export default node;
